import {UKey} from '../../core/data-source/data-source';
import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';
import {httpService} from '../../core/services/http.service';

export class DistributionCentreCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/aocs';
    async remove(ids: UKey[]): Promise<boolean> {
        return httpService.delete(this.apiPath, {
            params: {
                ids: ids.join(',')
            }
        });
    }
}
